import { render, staticRenderFns } from "./SwitchlangHeader.vue?vue&type=template&id=55e3dac0&scoped=true&"
import script from "./SwitchlangHeader.vue?vue&type=script&lang=ts&"
export * from "./SwitchlangHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchlangHeader.vue?vue&type=style&index=0&id=55e3dac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3dac0",
  null
  
)

export default component.exports